import React from 'react'
import { Helmet } from 'react-helmet'

import { Navbar, Footer, Landing, About, Skills, Testimonials, Blog, Education, Experience, Contacts, Projects, Services, Achievement, Hobbies, Counter} from '../../components'
// import Linkedin from '../../components/Linkedin/linkedin'
import Game from '../../components/Game/Game'
import Quote from '../../components/Quote/Quote'
import { headerData } from '../../data/headerData'
// import reportWebVitals from '../../components/Game/reportWebVitals';

function Main() {
    return (
        <div>

            
            <Helmet>
                <title>{headerData.name} - Porfolio</title>
                
            </Helmet>

            <Navbar />        
            <Landing />
            <About />
            <Counter/>
            <Skills />
            <Projects />
            <Experience/>
            <Achievement />
            <Education />
            <Hobbies/>            
            <Services/>
            <Testimonials/>
            <Blog /> 
            {/* <Music/> */}
            <Quote/>
            <React.StrictMode>
    {/* <Game /> */}
  </React.StrictMode>
            <Contacts />
            <Footer /> 
            
        </div>
       
    )
    // reportWebVitals();
}

export default Main
